import React, { useState } from 'react'
import '../assets/styles/modal.scss';
import moment from 'moment';
import closeIcon from '../images/icons/Icon2.png'

export const Action = (props) => {
  return (
      <div className="overlay" role="dialog">
      <div className="dialog sm-scrollbar">
        <div className="dialog__content">
          <img className="modal__close_icon" alt='Close' src={closeIcon} onClick={props.onClose} />
          <h2 className="dialog__title subheading-text-medium fontMedium">{props.title}</h2>
          <hr />
          {props.title==='Sectors Included'?<div className={`dialog__footer flexRow flexWrap ${props.fields.length > 1 ? 'justifyContentFlexStart' : 'justifyContentSpaceEvenly'}`}>
            {props.fields.map((item,index)=>{
              return   <span key={index} title={item} className="sector-label-view margBottom5 width25">{item}</span>
            })}
          </div>: <><div className='dialog__footer flexCol justifyContentSpaceBetween width30'>
                  <div className='flexCol sector-container justifyContentFlexStart'>
                    <span  className="sector-label-view margBottom5">Last update: {props.fields[0].latestUpdate.label} @ {moment(props.fields[0].latestUpdate.timestamp).tz(moment.tz.guess()).format("DD-MM-YYYY hh:mm A")}</span> 
                    <span  className="sector-label-view">Next update: {!Object.keys(props.fields[0].nxtUpdate).length?'NA':`${props.fields[0].nxtUpdate.label} @ ${moment(props.fields[0].nxtUpdate.timestamp).tz(moment.tz.guess()).format("DD-MM-YYYY hh:mm A")}`} </span> 
                </div>
                </div>
                </>
          }
        </div>
        <div className="dialog__footer flexRow justifyContentSpaceEvenly">
          <button className="done-button" onClick={props.onClose}>Done</button>
        </div>
      </div>
    </div>
  );
}
export const UpliftActionModal = (props) => {
  const [updated, setUpdated] = useState(null);

  const onChange = (e) => {
    const { name, value } = e.target;
    if(e.target.name==="itemType"){
      props.setItemTypeValue(e.target.value)
    };
    let newUpdates = updated ? { ...updated } : {}
    newUpdates[name] = value;
    setUpdated({ ...newUpdates });
    typeof (props.onChange) === 'function' && props.onChange(e,updated)
  }

  const onSubmit = (e) => {
    const mode=props.title;
    const updated = props.fields[0].value;
    removeContainerOverlay();
    typeof (props.onSubmit) === 'function' && props.onSubmit(e, updated,mode)
  }

  const onClose = (e) => {
    removeContainerOverlay();
    props.onClose();
  }

  const removeContainerOverlay = () => {
    /**
     * Remove overlay to parent class
     */
    (document.querySelectorAll('.content-container')[0]).classList.remove('modal-overlay-bg2');
  };

  return (
    <Action
      title={props.title}
      fields={props.fields}
      onClose={onClose}
      onChange={onChange}
      onSubmit={(e) => onSubmit(e)}>
    </Action>
  )
}